import React, { useEffect } from 'react';

import './Chat.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';

const { LeftArrow } = icons;

export default function Chat(props) {
  const { room, user, sendRoomMessage, refetch } = props;
  const { unreadCount, subject, messages, identifier } = room;

  const newMessages = unreadCount ? messages.slice(-unreadCount) : [];
  const oldMessages = unreadCount ? messages.slice(0, -unreadCount) : messages;

  useEffect(() => {
    const refreshMessages = setInterval(() => {
      refetch();
    }, 10000);

    return () => clearInterval(refreshMessages);
  }, []);

  useEffect(() => {
    const list = document.querySelector('.chat_content');

    if (list) list.scrollTop = list.scrollHeight;
  });

  return (
    <section className="chat">
      <div className="dashboardCategoryTitle">
        {link(
          <span>
            <LeftArrow />
          </span>,
          '/rooms',
          props.nextLink
        )}

        <h2>{subject}</h2>
      </div>

      <div className="chat_content">
        {!!oldMessages.length && (
          <MessageList messages={oldMessages} user={user} />
        )}

        {!!newMessages.length && (
          <React.Fragment>
            <div className="chat_message_separator">
              <hr />
              <span>New messages</span>
              <hr />
            </div>

            <MessageList messages={newMessages} user={user} />
          </React.Fragment>
        )}
      </div>

      <form onSubmit={(e) => sendMessage(e)} className="chat_new_message">
        <textarea name="message" rows="6" placeholder="Typ een bericht..." />

        <button type="submit">Verzenden</button>
      </form>
    </section>
  );

  function sendMessage(e) {
    e.preventDefault();

    const message = e.target.message.value.trim();

    if (!message) return;

    sendRoomMessage({ variables: { roomIdentifier: identifier, message } });

    e.target.message.value = '';
  }
}

function MessageList(props) {
  return (
    <ul>
      {props.messages.map((msg) => {
        const date = new Date(`${msg.createdAt}Z`);

        const isUserMessage = msg.authorAccountName === props.user.username;

        return (
          <li className="chat_message" key={msg.xuid}>
            <div className="chat_message_image">
              <img src={msg.authorPictureUrl} alt="author-image" />
            </div>

            <div>
              <span className="chat_message_author">
                {msg.authorDisplayName}
              </span>

              <span className="chat_message_date">
                {date.toLocaleString('en-US', {
                  dateStyle: 'long',
                  timeStyle: 'short',
                  timeZone: 'UTC'
                })}
              </span>

              <div
                className={getString([
                  {
                    value: 'chat_message_text',
                    condition: true
                  },
                  {
                    value: 'chat_user_message',
                    condition: isUserMessage
                  }
                ])}
                dangerouslySetInnerHTML={{ __html: msg.messageHtml }}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
